import { Link } from "react-router-dom";
import { CONTACT } from "../data/content";
import { Mail, Phone, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets-v7afamib.emergentagent.net/job_9e2c448a-18b6-4072-a034-48f10e8b6302/artifacts/xaazidaz_TMG%20WHITE%20LOGO.PNG";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0A] text-[#E5E7EB] grain">
      <div className="container-wide py-20 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="md:col-span-1">
            <img src={LOGO_URL} alt="The Mogul Group" className="h-16 w-auto mb-4" />
            <p className="text-sm text-[#A1A1AA] leading-relaxed max-w-xs">
              Strategic business consulting, brand growth, and operations support for owner-led businesses. Dallas–Fort Worth based, serving businesses nationwide.
            </p>
          </div>

          <div>
            <div className="overline mb-4">Explore</div>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-link-services" to="/services" className="hover:text-gold">Services</Link></li>
              <li><Link data-testid="footer-link-industries" to="/industries" className="hover:text-gold">Industries</Link></li>
              <li><Link data-testid="footer-link-how" to="/how-we-help" className="hover:text-gold">How We Help</Link></li>
              <li><Link data-testid="footer-link-packages" to="/packages" className="hover:text-gold">Packages</Link></li>
              <li><Link data-testid="footer-link-about" to="/about" className="hover:text-gold">About</Link></li>
              <li><Link data-testid="footer-link-founder" to="/founder" className="hover:text-gold">Founder</Link></li>
              <li><Link data-testid="footer-link-portfolio" to="/portfolio" className="hover:text-gold">Client Work</Link></li>
            </ul>
          </div>

          <div>
            <div className="overline mb-4">Get in touch</div>
            <ul className="space-y-3 text-sm">
              <li className="flex gap-2 items-start"><MapPin className="w-4 h-4 mt-0.5 shrink-0" strokeWidth={1.5} /><span>{CONTACT.address_line_1}<br/>{CONTACT.address_line_2}</span></li>
              <li className="flex gap-2 items-center"><Mail className="w-4 h-4 shrink-0" strokeWidth={1.5} /><a href={`mailto:${CONTACT.email}`} className="hover:text-gold">{CONTACT.email}</a></li>
              <li className="flex gap-2 items-center"><Phone className="w-4 h-4 shrink-0" strokeWidth={1.5} /><a href={CONTACT.phone_href} className="hover:text-gold">{CONTACT.phone}</a></li>
            </ul>
            <Link to="/growth-assessment" data-testid="footer-cta-assessment" className="btn btn-primary mt-6">Get My Free Growth Assessment</Link>
          </div>

          <div>
            <div className="overline mb-4">Company</div>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-link-contact" to="/contact" className="hover:text-gold">Contact</Link></li>
              <li><Link data-testid="footer-link-assessment" to="/growth-assessment" className="hover:text-gold">Growth Assessment</Link></li>
              <li><Link data-testid="footer-link-privacy" to="/privacy" className="hover:text-gold">Privacy Policy</Link></li>
              <li><Link data-testid="footer-link-terms" to="/terms" className="hover:text-gold">Terms & Conditions</Link></li>
              <li><Link data-testid="footer-link-accessibility" to="/accessibility" className="hover:text-gold">Accessibility</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row gap-4 sm:items-center sm:justify-between text-xs text-[#A1A1AA]">
          <div>© {year} The Mogul Group, LLC. All rights reserved.</div>
          <div>Dallas–Fort Worth Based · Serving Businesses Nationwide</div>
        </div>
      </div>
    </footer>
  );
}
